var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6fb32f;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,32A16,16,0,1,1,32,16,16.018,16.018,0,0,1,16,32ZM.661,16h0A15.355,15.355,0,0,0,16,31.337,15.355,15.355,0,0,1,.662,16ZM10,15a1,1,0,0,0-.625,1.781l5,4a1,1,0,0,0,1.376-.122l7-8a1,1,0,0,0-1.5-1.318l-6.371,7.281-4.253-3.4A1,1,0,0,0,10,15Z",
    transform: "translate(0.5 0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigDone);
export default __webpack_public_path__ + "static/media/config-done.1434f35e99195541b76be6f6e761d9df.svg";
export { ForwardRef as ReactComponent };